import { documentApi } from 'resources/signnow/api';

const updateAttachedSignDocumentIdsByDiff = async (listedkitId, attachedSignDocumentIdsDiff) => {
  const { added: attachedSignDocumentIdsToAdd, deleted: attachedSignDocumentIdsToDelete } = attachedSignDocumentIdsDiff;

  const addPromises = Promise.all(
    attachedSignDocumentIdsToAdd.map((documentId) => (
      documentApi.attachToListedkit({
        documentId,
        listedkitId,
      })
    )) || [],
  );

  const deletePromises = Promise.all(
    attachedSignDocumentIdsToDelete.map((documentId) => documentApi.detachFromListedkit({
      documentId,
      listedkitId,
    }) || []),
  );

  const [created, deleted] = await Promise.all([addPromises, deletePromises]);

  return { created, deleted };
};

export { updateAttachedSignDocumentIdsByDiff };
